import _asyncToGenerator from "D:/wwwroot/dealer-web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: 'index',
  components: {},
  data: function data() {
    return {
      randBackgroundColor: ['#EBF1F6', '#DDE8F0', '#F5F7FA', '#E4E9EE', '#F5F8FB'],
      shortcutsList: [{
        title: '寄售库存',
        icon: 'th-large',
        path: '/stock/detail/consign'
      }, {
        title: '寄售订货订单',
        icon: 'th-large',
        path: '/order/consign'
      }, {
        title: '报台中心',
        icon: 'th-large',
        path: '/report/center'
      }, {
        title: '采购订货单',
        icon: 'th-large',
        path: '/order/purchase'
      }],
      todoList: [],
      announceList: [],
      todoColumns: [{
        label: '待办事项',
        prop: 'manuName',
        checked: true,
        width: 300
      }, {
        label: '时间',
        prop: 'time',
        checked: true,
        fixedWidth: 200
      }],
      announceColumns: [{
        label: '类型',
        prop: 'type',
        fixedWidth: 100,
        slot: 'type'
      }, {
        label: '标题',
        prop: 'title',
        checked: true,
        width: 300
      }, {
        label: '时间',
        prop: 'time',
        checked: true,
        fixedWidth: 200
      }]
    };
  },
  created: function created() {},
  mounted: function mounted() {
    this.init();
  },
  methods: {
    init: function init() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var that;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                that = _this;

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    getBackgroundColor: function getBackgroundColor() {
      var color = this.randBackgroundColor[parseInt(Math.random() * 4)];
      return color;
    },
    navClick: function navClick(path) {
      this.$router.push({
        path: path
      });
    }
  }
};